<template>
    <div class="container prodcont" :class="{opscss: opscsstheme==='opscss'}">
        <div class="prodcont1  card shadow">
            <div class="row">
                <div class="col" v-for="osprod in opsproducts">
                   <div v-html="osprod.opshortdesc" class="prodsdiv"></div>
                </div>
              </div>
        </div>
        
    </div>
</template>

<script>
export default {
    props: ['opsproducts',],
}
</script>

<style scoped>
.prodsdiv {
    width: 70%;
}

.prodcont1 {
    background-color: whitesmoke;
    border-radius: 5px;
    margin-top: 120px;
}
.row {
    padding: 20px;
    margin-top: -50px;
}

 /*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
    .col {
      width: 100%;;
    
     } 
     .prodsdiv {
        width: 100%;
        padding-top: 40px;
    }
    .prodcont {
       margin-bottom: 100px;
        width: 100%;
        height: auto;
        padding: 10px;
    }

   
   }
  
   /* Small devices (portrait tablets and large phones, 600px and up) */
   @media only screen and (min-width: 600px) {
    .col {
        width: 100%;;
      
       } 
       .prodsdiv {
          width: 100%;
          padding-top: 40px;
      }
      .prodcont {
         margin-bottom: 100px;
          width: 100%;
          height: auto;
          padding: 10px;
      }
   }
   
   /* Medium devices (landscape tablets, 768px and up) */
   @media only screen and (min-width: 768px) {
    .col {
        width: 100%;;
      
       } 
       .prodsdiv {
          width: 100%;
          padding-top: 40px;
      }
      .prodcont {
         margin-bottom: 100px;
          width: 100%;
          height: auto;
          padding: 10px;
      }
   }
   
   /* Large devices (laptops/desktops, 992px and up) */
   @media only screen and (min-width: 992px) {
  
   }
   
   /* Extra large devices (large laptops and desktops, 1200px and up) */
   @media only screen and (min-width: 1200px) {
      
   } 
</style>